<template>
    <div v-if="products.length > 0">
        <h2 class="posr">
            {{ products_title }}
            <router-link 
                v-if="to"
                :to="to"
                class="posa">
                {{ products_more }}
            </router-link>
        </h2>
        <ul v-if="!isBackgroundStyle" class="row">
            <li class="col-sm-6 col-md-4 col-xl-3" v-for="(product,index) in products" v-bind:key="index">
                <ProductItem :product="product" /> <!-- product自取="v-for的東西名稱" -->
            </li>
        </ul>
        <ul v-if="isBackgroundStyle" class="product_notice row">
            <ItemBackgroundStyle v-for="(product,index) in products" v-bind:key="index" :product="product"></ItemBackgroundStyle>
        </ul>
    </div>
</template>

<script>
    import ProductItem from '@/components/products/items/Item'
    import ItemBackgroundStyle from '@/components/products/items/ItemBackgroundStyle'

    export default {
        props: {
            products: { // 讓他人可以使用的參數，可定哪種屬型是否為true
                type: Array,
                required: true
            },
            products_title: {
                type: String,
                required: true
            },
            products_more: {
                type: String,
                default() {
                    return '更多課程';
                }
            },
            to: [String, Object],
            isBackgroundStyle: {
                type: Boolean,
                default() {
                    return false;
                },
            }
        },
        name: 'ProductItemBox',
        components: {
            ProductItem,
            ItemBackgroundStyle,
        },
    }
</script>